export var DEFAULT_CURRENCY_CODE = 'USD';
export var DEFAULT_LOCALE = 'en';
export function currencyFormat(_a) {
    var _b = _a.locale, locale = _b === void 0 ? DEFAULT_LOCALE : _b, _c = _a.currency, currency = _c === void 0 ? DEFAULT_CURRENCY_CODE : _c;
    // tslint:disable-next-line:no-string-literal
    var Intl = typeof window === 'undefined' ? null : window['Intl'];
    return Intl
        ? new Intl.NumberFormat(locale.replace('_', '-'), {
            style: 'currency',
            currency: currency,
        }).format
        : fallback(currency);
}
var fallback = function (currency) { return function (amount) { return "" + currency + amount; }; };
//# sourceMappingURL=currency-format.js.map